import { useEffect, useState } from 'react';
import { Form as FormType } from '../../types/schema';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface FormsDeleteModalProps {
    selectedForm: FormType | null;
    isDeleting: boolean;
    onDismiss: () => void;
    onConfirmDelete: () => void;
}

export const FormsDeleteModal = ({ selectedForm, isDeleting, onDismiss, onConfirmDelete }: FormsDeleteModalProps) => {
    const visible = Boolean(selectedForm?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    // Avoid click-through from the trash icon activating Delete as the modal opens.
    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, selectedForm?.id]);

    const formName = selectedForm?.name?.trim() || 'this form';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Delete form?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isDeleting}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isDeleting ? 'Deleting...' : 'Delete'}
                        buttonDisabled={isDeleting || !confirmReady}
                        buttonOnClick={onConfirmDelete}
                    />
                </div>
            }
        >
            <p>
                You are about to permanently delete <strong>“{formName}”</strong>. This cannot be undone.
            </p>
        </CustomModal>
    );
};
